/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5f8a85bc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5f8a85bc&lang=less"

import exportComponent from "/Users/chenqi/data/wwwroot/car.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__